import type { EmployerBankAccount } from '@kora/types';
import { apiRequest } from './client.js';

/** Tenant bank profile (bank-export feature). Self-documentation only. */
export interface BankProfileView {
  accounts: EmployerBankAccount[];
  narrationTemplate: string | null;
  updatedAt: string | null;
}

/** GET /v1/bank-profile/me */
export function getBankProfile(): Promise<BankProfileView> {
  return apiRequest<BankProfileView>('/v1/bank-profile/me');
}

/** PUT /v1/bank-profile/me */
export function saveBankProfile(body: {
  accounts: EmployerBankAccount[];
  narrationTemplate?: string | null;
}): Promise<BankProfileView> {
  return apiRequest<BankProfileView>('/v1/bank-profile/me', { method: 'PUT', body });
}
